export default __webpack_public_path__ + "static/blog-placeholder-92d1aacb801e5681f81b67d3b54716c4.jpg";